import { authHeader } from '@/_helpers';

export const linksService = {
    createComment,
    createEvent,
    copyEvent,
    updateAttendanceStatus,
    getTodayMeetings,
    getMeetingsStatusProcessed,
    getOpportunitiesByClient,
    getActiveRefuse,
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function createComment(linkId, comment) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ comment })
    };
    return fetch(`${apiUrl}/links/${linkId}/comments`, requestOptions).then(handleResponse);
}

function createEvent(linkId, eventId, remark, eventDate, business_contact_id = 0) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ eventId, remark, eventDate, business_contact_id })
    };
    return fetch(`${apiUrl}/links/${linkId}/events`, requestOptions).then(handleResponse);
}

function copyEvent( link_id, params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ link_id, params })
    };
    return fetch(`${apiUrl}/links/copy`, requestOptions).then(handleResponse);
}

function updateAttendanceStatus(meetingId, attendanceStatus) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ attendance_status: attendanceStatus })
    };
    return fetch(`${apiUrl}/links/events/${meetingId}/attendance-status`, requestOptions).then(handleResponse);
}

function getTodayMeetings() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/links/meetings/today`, requestOptions).then(handleResponse);
}

function getMeetingsStatusProcessed(searchFilter) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({searchFilter})
    };
    return fetch(`${apiUrl}/links/meetings/processed_status`, requestOptions).then(handleResponse);
}

function getOpportunitiesByClient(id){
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/links/opportunities-by-client/${id}`, requestOptions).then(handleResponse);
}

function getActiveRefuse(linkId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/links/active-refuse/${linkId}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}